module.exports = __webpack_public_path__ + "static/media/arrow-top.a646261d.svg";